import Vue from 'vue';

// Chromium fires `beforeinstallprompt` once, very early in the page load, and only when the app
// currently meets the install criteria. A component that registers its own listener on mounted()
// misses it whenever its chunk is still loading, which is the normal case for a lazily imported
// view: the install button then never appears. App.vue captures the event on created() and parks
// it here, so anything that wants to offer the install reads it from this store instead.
export const pwaInstallState = Vue.observable({
    deferredPrompt: null as any
});

export const capturePwaInstallPrompt = (event: any): void => {
    // Keeping the event means the browser shows no banner of its own; we decide when to prompt.
    event.preventDefault();
    pwaInstallState.deferredPrompt = event;
};

export const canPromptPwaInstall = (): boolean => pwaInstallState.deferredPrompt !== null;

// Returns true when the user accepted. The event can only be used once, so it is dropped either
// way: the browser will fire a fresh one if the app is still installable.
export const promptPwaInstall = async (): Promise<boolean> => {
    const prompt = pwaInstallState.deferredPrompt;
    if (!prompt) {
        return false;
    }
    pwaInstallState.deferredPrompt = null;
    const result = await prompt.prompt();
    return result.outcome === 'accepted';
};
